/**
 * Created by Edward on 15/05/2017.
 */

import SliderTextCounter from './SliderTextCounter'

export default SliderTextCounter
